import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as Flash from '../../components/flash-message'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Utils from '../../utils'
import * as Actions from './actions'
import * as Constants from './constants'

export const onExport = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Request.successConstant(Constants.EXPORT_SOURCES))
  .map((action) => {
    const csvHeaders: Utils.CSVHeader[] = [
      {name: 'name', displayName: 'name'},
      {name: 'source_identifier', displayName: 'source_identifier'},
      {name: 'source_type', displayName: 'source_type'},
      {name: 'subscription_type', displayName: 'subscription_type'},
      {name: 'include_filters', displayName: 'include_filters'},
      {name: 'include_filter_groups', displayName: 'include_filter_groups'},
      {name: 'include_matches', displayName: 'include_matches'},
      {name: 'exclude_filters', displayName: 'exclude_filters'},
      {name: 'exclude_filter_groups', displayName: 'exclude_filter_groups'},
      {name: 'exclude_matches', displayName: 'exclude_matches'},
      {name: 'category_type', displayName: 'category_type'},
      {name: 'filter_attribute', displayName: 'filter_attribute'},
      {name: 'filter_value', displayName: 'filter_value'},
    ]
    return Utils.downloadCSV(action.payload.response, csvHeaders);
  })

const sourceFilterSelector: IsActive.FilterSelector = (state: ApplicationState) => state.sources.view.filter
export const epic = ReduxObservable.combineEpics(
  Flash.createFlashSuccessEpic(Constants.ADD_SOURCE, 'Source added'),
  IsActive.createFilterAddedEpic(Constants.ADD_SOURCE, Actions.fetchSources, sourceFilterSelector),
  IsActive.createFilterChangeEpic(Constants.FETCH_SOURCES, Actions.fetchSources, sourceFilterSelector),
  IsActive.createNavigateToPageEpic(Menu.CONTENT_SOURCES_URL, Actions.fetchSources, sourceFilterSelector),
  IsActive.createStatusUpdateEpic(Constants.UPDATE_SOURCE_INLINE, Actions.updateStatus),
  onExport,
)



// WEBPACK FOOTER //
// ./src/pages/sources/epic.ts